export enum ProjectType {
	PROJECTS = 'PROJECTS',
	PURCHASES = 'PURCHASES',
}
